
export const notify = async (store, title, typeSlug='success', position='tc') => {
    console.log('set notification!!!', title, typeSlug);
    let notification = {
        place: position,
        message: title,
        type: typeSlug,
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 7
    };
    store.setState({ notification });
};
